import React from 'react';
import Chip from '@mui/material/Chip';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { DealPostType } from '../../../../types';

interface DealCardProps extends DealPostType {
  setPromotionFilter: (promotion: string) => void;
  promotionAmount: number;
  promotionFilter: string;
}

const FilterByPromotionChip = ({
  setPromotionFilter,
  extraDealLink,
  extraDeal,
  promotionAmount,
  promotionFilter
}: DealCardProps) => {
  if (promotionAmount < 2) {
    return null;
  }
  return (
    <Chip
      label={
        promotionFilter !== 'all'
          ? 'Clear filter'
          : `(${promotionAmount} deals) Filter by ${extraDeal.toLowerCase()}`
      }
      size="small"
      clickable
      icon={<FilterAltIcon />}
      onClick={() => {
        if (promotionFilter === extraDeal) {
          setPromotionFilter('all');
        } else {
          setPromotionFilter(extraDealLink);
        }
      }}
      style={{ margin: '2px' }}
      onDelete={
        promotionFilter !== 'all' ? () => setPromotionFilter('all') : undefined
      }
    />
  );
};

export default FilterByPromotionChip;
